import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import { MAIN_CONTENT_MENU_ENABLED } from '../constants/app-constants';

//template
import TemplateRoute from './template-route';
import Analytics from '../pages/analytics';

//components
import AppLoader from '../components/loader';

//pages
import Login from '../pages/login';
import Banner from '../pages/banner';
import UserManagement from '../pages/user';
import LiveChat from '../pages/live-chat';
import HighlightBox from '../pages/highlight-box';
import QuickLink from '../pages/quick-link';
import MainContent from '../pages/main-content';
import News from '../pages/news';
import ServiceLink from '../pages/service-link';
import Notification from '../pages/notification';
import Activity from '../pages/activity';
import TemplateContent from '../pages/template-content';
import Menu from '../pages/menu';
import Photo from '../pages/gallery/photo';
import Video from '../pages/gallery/video';
import Document from '../pages/gallery/document';
import ForgotPassword from '../pages/forgot-password';
import ResetPassword from '../pages/reset-password';
import Profile from '../pages/profile';
import FooterLink from '../pages/footer-link';
import FeatureConfig from '../pages/feature-config';
import WebsiteUser from '../pages/website-user';
import Program from '../pages/program';
import Slider from '../pages/slider';
import IntranetManagement from '../pages/intranet';

const AppRouteContainer = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Login} />
                <TemplateRoute exact path="/user-management" component={UserManagement} />
                <TemplateRoute exact path="/live-chat" component={LiveChat} />
                <TemplateRoute exact path="/analytics" component={Analytics} />
                <TemplateRoute exact path="/banner" component={Banner} />
                <TemplateRoute exact path="/highlight-box" component={HighlightBox} />
                <TemplateRoute exact path="/quick-link" component={QuickLink} />
                {/* NMU-564: while the module is hidden, a direct visit to
                    /main-content lands on Splash Page instead of the unused
                    editor. The route comes back with the flag. */}
                {MAIN_CONTENT_MENU_ENABLED
                    ? <TemplateRoute exact path="/main-content" component={MainContent} />
                    : <Redirect exact from="/main-content" to="/notification" />}
                <TemplateRoute exact path="/news" component={News} />
                <TemplateRoute exact path="/service-link" component={ServiceLink} />
                <TemplateRoute exact path="/footer-link" component={FooterLink} />
                <TemplateRoute exact path="/notification" component={Notification} />
                <TemplateRoute exact path="/activity" component={Activity} />
                <TemplateRoute exact path="/program" component={Program} />
                <TemplateRoute exact path="/slider" component={Slider} />
                {/* NMU-478 / NMU-496: four sub-modules over one component — the
                    card shape is identical, only the section differs. */}
                <TemplateRoute exact path="/intranet/workspace" component={() => <IntranetManagement moduleKey="workspace" />} />
                <TemplateRoute exact path="/intranet/hr-admin" component={() => <IntranetManagement moduleKey="hr-admin" />} />
                <TemplateRoute exact path="/intranet/operations" component={() => <IntranetManagement moduleKey="operations" />} />
                <TemplateRoute exact path="/intranet/internal-comm" component={() => <IntranetManagement moduleKey="internal-comm" />} />
                <TemplateRoute exact path="/template-content" component={TemplateContent} />
                <TemplateRoute exact path="/menu" component={Menu} />
                <TemplateRoute exact path="/gallery/photo" component={Photo} />
                <TemplateRoute exact path="/gallery/video" component={Video} />
                <TemplateRoute exact path="/gallery/document" component={Document} />
                <TemplateRoute exact path="/feature-config" component={FeatureConfig} />
                <TemplateRoute exact path="/website-user" component={WebsiteUser} />
                <TemplateRoute exact path="/profile" component={Profile} />
                <Route exact path="/forgotPassword" component={ForgotPassword} />
                <Route exact path="/user/resetPassword/:token" component={ResetPassword} />
            </Switch>
            <AppLoader />
        </BrowserRouter>
    )
}

export default AppRouteContainer;